module.exports = __webpack_public_path__ + "static/commercial-cover-e6081899a675a307a6a5bacaf60cfdbb.jpg";